module.exports = __webpack_public_path__ + "01_veryshort_black.d133dc37.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/01_veryshort_black.png
// module id = YZYe
// module chunks = 0